var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLillyPaymentHero({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 257.87 309.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#fabe78;}.cls-4{fill:#fcee21;}.cls-5{opacity:0.5;}.cls-16,.cls-35,.cls-6{fill:#fff;}.cls-23,.cls-7,.cls-9{fill:#93a8d4;}.cls-16,.cls-24,.cls-7,.cls-8{opacity:0.2;}.cls-10{fill:url(#linear-gradient);}.cls-11,.cls-27,.cls-28,.cls-32,.cls-33{opacity:0.4;}.cls-11,.cls-27,.cls-28,.cls-32,.cls-33,.cls-42{mix-blend-mode:overlay;}.cls-11{fill:url(#linear-gradient-2);}.cls-12{fill:url(#linear-gradient-3);}.cls-13,.cls-14{fill:#dce7f7;}.cls-14,.cls-15,.cls-23{mix-blend-mode:multiply;}.cls-17{clip-path:url(#clip-path);}.cls-18{fill:#90f4e1;}.cls-19{fill:url(#linear-gradient-4);}.cls-20{fill:url(#linear-gradient-5);}.cls-21{fill:url(#linear-gradient-6);}.cls-22{fill:#e6e6e6;}.cls-23{opacity:0.3;}.cls-24{fill:#f2f2f2;}.cls-25{fill:url(#linear-gradient-7);}.cls-26{fill:url(#radial-gradient);}.cls-27{fill:url(#linear-gradient-8);}.cls-28{fill:url(#linear-gradient-9);}.cls-29{fill:url(#linear-gradient-10);}.cls-30{fill:url(#linear-gradient-11);}.cls-31{opacity:0.6;}.cls-32{fill:url(#linear-gradient-12);}.cls-33{fill:url(#linear-gradient-13);}.cls-34{fill:#f7931e;opacity:0.7;mix-blend-mode:color-dodge;}.cls-35,.cls-36,.cls-42{opacity:0.8;}.cls-37{fill:url(#linear-gradient-14);}.cls-38{fill:url(#linear-gradient-15);}.cls-39{fill:url(#linear-gradient-16);}.cls-40{fill:url(#linear-gradient-17);}.cls-41{fill:url(#linear-gradient-18);}.cls-43{fill:url(#linear-gradient-19);}.cls-44{fill:url(#linear-gradient-20);}.cls-45{fill:url(#linear-gradient-21);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 185.4,
    y1: -47.42,
    x2: 95.72,
    y2: 326.23,
    gradientTransform: "matrix(-1, 0, 0, 1, 272.82, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#90f4e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#069efc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 72.88,
    y1: 56.89,
    x2: 200.92,
    y2: 247.3,
    gradientTransform: "matrix(-1, 0, 0, 1, 272.82, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15b3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 139.68,
    y1: 9.52,
    x2: 149.3,
    y2: 301.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.56,120.87v34s-11.35,3.2-14.16,4.51-4.64,2.18-5.47,3.35a2.86,2.86,0,0,0-.64,2.07l0,106.57,105.2,1.77,1.36-142.23Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 108.12,
    y1: 218.59,
    x2: 44.14,
    y2: 218.16,
    gradientTransform: "matrix(-1, 0, 0, 1, 272.82, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#4edcc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#34d7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#1dd2af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0dcfa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#03cda6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00cca5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 64.96,
    y1: 167.11,
    x2: 117.99,
    y2: 167.11,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 64.89,
    y1: 166.71,
    x2: 101.77,
    y2: 166.89,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 197.05,
    y1: 151.08,
    x2: 207.92,
    y2: 32.17,
    gradientTransform: "matrix(-1, 0, 0, 1, 272.82, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#90f4e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#069efc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 207.54,
    cy: 118.81,
    r: 166.8,
    gradientTransform: "matrix(-1, 0, 0, 1, 272.82, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#aad36a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#53b7b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1ba5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#069efc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#90f4e1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 215.86,
    y1: 76.29,
    x2: 210.29,
    y2: 133.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 185.03,
    y1: 98.84,
    x2: 206.55,
    y2: 98.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 216.54,
    y1: 293.35,
    x2: 208.64,
    y2: 137.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 34.37,
    y1: 144.13,
    x2: 332.46,
    y2: 225.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 132.68,
    y1: 246.86,
    x2: 264.52,
    y2: 158.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 220.73,
    y1: 133.2,
    x2: 205.69,
    y2: 262.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 223.17,
    y1: -49.69,
    x2: 234.04,
    y2: 32.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 226.42,
    y1: -50.13,
    x2: 237.29,
    y2: 32.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 187.1,
    y1: -44.93,
    x2: 197.97,
    y2: 37.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 132.49,
    y1: -37.71,
    x2: 143.37,
    y2: 44.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 120.26,
    y1: -36.09,
    x2: 131.14,
    y2: 46.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 153.8,
    y1: -38.38,
    x2: 214.16,
    y2: 60.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 123.33,
    y1: -19.7,
    x2: 183.69,
    y2: 78.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 113.17,
    y1: -13.46,
    x2: 173.53,
    y2: 84.97,
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lilly-payment-heroAsset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.9,147.76c-8.8,1.59-15,11.34-13.89,21.79s9.15,17.62,18,16,15-11.33,13.89-21.77S231.69,146.18,222.9,147.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M225.32,148.47c-8.8,1.59-15,11.34-13.89,21.79s9.15,17.62,17.95,16,15-11.33,13.89-21.77S234.12,146.89,225.32,148.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M211.42,170.26a19.77,19.77,0,0,0,5.3,11.76,20.06,20.06,0,0,1-4.7-11.13c-1.12-10.44,5.09-20.2,13.89-21.79a14.07,14.07,0,0,1,12.58,4.2,14.13,14.13,0,0,0-13.17-4.83C216.53,150.06,210.31,159.81,211.42,170.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M220.16,180.56a15.52,15.52,0,0,1-5.82-10.87c-.91-8.44,4.17-16.35,11.32-17.64h0a11.33,11.33,0,0,1,8.88,2.17,15.48,15.48,0,0,1,5.82,10.86c.91,8.44-4.17,16.36-11.32,17.65a11,11,0,0,1-2,.18A11.5,11.5,0,0,1,220.16,180.56Zm5.7-27.4h0c-6.58,1.18-11.25,8.55-10.4,16.41a14.39,14.39,0,0,0,5.38,10.08,10.23,10.23,0,0,0,8,2c6.58-1.19,11.25-8.55,10.4-16.42a14.41,14.41,0,0,0-5.37-10.08,10.3,10.3,0,0,0-6.22-2.12A9.85,9.85,0,0,0,225.86,153.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M66.55,268.38c0,1.82,2.16,3.53,5.25,4l104.27,15.49,2.62.4,1.41.2c8.86,1.33,17.34-1.89,18.94-7.18.64-2.07-1.68-4.16-5.14-4.67L85.59,260.51c-8.84-1.32-17.32,1.89-18.94,7.18A2.3,2.3,0,0,0,66.55,268.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.61,286.22a1.83,1.83,0,0,0,.29-3.64L2.47,264a1.83,1.83,0,0,0-.58,3.62L119.32,286.2A1.46,1.46,0,0,0,119.61,286.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M99.69,35.33l71.79,10.2c8.15,1.14,14.77,9.21,14.79,18l.36,195.64c0,11.18-11,19.46-19.11,18.31l-67.41-14.66c-8.15-1.14-14.76-9.21-14.77-18L79.07,52C79.05,43.22,89.16,34,99.69,35.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M84.68,40.51a18.32,18.32,0,0,1,12.75-3.37l71.79,10.19c8.15,1.16,14.78,9.21,14.78,18L184.37,261a18.4,18.4,0,0,1-6.2,13.5,18.92,18.92,0,0,0,8.45-15.31l-.34-195.63c0-8.79-6.65-16.86-14.81-18L99.69,35.33A18.88,18.88,0,0,0,84.68,40.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.7,39.85l71.79,10.2c8.15,1.14,14.78,9.21,14.79,18l.37,195.64c0,8.79-6.59,15-14.73,13.85l-71.8-10.2c-8.14-1.14-14.75-9.21-14.77-18L79,53.7C79,44.91,85.55,38.7,93.7,39.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M79,53.71l.37,195.63c0,8.79,6.62,16.86,14.76,18l71.8,10.21a12.33,12.33,0,0,0,11.23-4.07,12.39,12.39,0,0,1-10.94,3.73L94.4,267c-8.15-1.14-14.76-9.2-14.76-18L79.27,53.37a14.84,14.84,0,0,1,2.87-9A14.66,14.66,0,0,0,79,53.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M88,49.37l83.28,11.82c4.2.59,7.62,4.76,7.62,9.29l.36,191.44c0,4.54-3.39,7.75-7.59,7.16L88.37,257.26c-4.2-.59-7.61-4.76-7.62-9.29L80.39,56.53C80.38,52,83.78,48.78,88,49.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M80.4,56.53,80.75,248c0,4.54,3.41,8.71,7.62,9.3l83.28,11.81a6.57,6.57,0,0,0,4.15-.76,6.64,6.64,0,0,1-3.16.31L89.36,256.81c-4.2-.58-7.62-4.76-7.62-9.3L81.39,56.08a7.08,7.08,0,0,1,3.43-6.4A7,7,0,0,0,80.4,56.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M136,52.85l-18.49-2.6a1.68,1.68,0,0,1-1.37-1.65,1.21,1.21,0,0,1,1.37-1.28L136,49.92a1.69,1.69,0,0,1,1.37,1.66A1.2,1.2,0,0,1,136,52.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M148,55.3a2.54,2.54,0,0,1-2.05-2.51A1.82,1.82,0,0,1,148,50.85a2.56,2.56,0,0,1,2.07,2.52A1.82,1.82,0,0,1,148,55.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M116.12,48.6a1.68,1.68,0,0,0,1.37,1.65L136,52.85a1.1,1.1,0,0,0,1-.34,1.6,1.6,0,0,1-.31,0L118.2,49.92a1.7,1.7,0,0,1-1.37-1.65,1.32,1.32,0,0,1,.36-1A1.23,1.23,0,0,0,116.12,48.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M145.93,52.79A2.56,2.56,0,0,0,148,55.3a1.72,1.72,0,0,0,1.36-.35,2,2,0,0,1-.64,0,2.53,2.53,0,0,1-2.05-2.51,2,2,0,0,1,.72-1.59A1.88,1.88,0,0,0,145.93,52.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M79,53.7l0,10.92L180.5,187.69l-.22-119.63c0-8.8-6.64-16.87-14.79-18L93.7,39.84C85.56,38.7,79,44.92,79,53.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79.16,137.12l1.21,82.41,51.13,7.18c3.5.49,6.34-2.16,6.33-5.94l-.14-69.09a7.84,7.84,0,0,0-6.33-7.72Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M166.28,164.67v88.26c.23,1.56,2.07,3.32,6.1,5.36,22.5,11.43,72,6.25,72,6.25V176.39a270.18,270.18,0,0,1-37.48.85h0c-12.56-.67-25.62-2.6-34.48-7.1-4-2-5.85-3.79-6.1-5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M160.85,118.34V206.5s2.11.73,5.43,2V164.67a1.19,1.19,0,0,1,0-.46c.62-6.76,31.59-9.82,39.42-17.41a3.52,3.52,0,0,0,1.16-2.19v-.56C206.18,134.08,160.85,118.34,160.85,118.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M166.28,164.21a1.19,1.19,0,0,0,0,.46v.12c.25,1.56,2.08,3.31,6.1,5.35,8.86,4.5,21.92,6.43,34.48,7.1V144.61a3.52,3.52,0,0,1-1.16,2.19C197.87,154.39,166.9,157.45,166.28,164.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M166.27,181.39V245.7c.76.46,1.62.94,2.59,1.43,10.08,5.12,24.93,7.31,39.22,8.08h0c2,.12,3.88.19,5.8.24,0-.12.1-.25.16-.37,2.14-5.11,8.19-9.12,15.78-10.44V203.75c-8.67-1.5-15.29-6.48-16.45-12.62a2.14,2.14,0,0,1-.06-.35l-5.23.13h0c-14.29-.78-29.14-3-39.22-8.09C167.89,182.33,167,181.85,166.27,181.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M160.84,125.74v80.77s2.12.73,5.43,2V164.67a1.69,1.69,0,0,1,0-.45c.6-6.5,29.21-9.58,38.4-16.54C195.69,139.31,171.46,129.69,160.84,125.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M171.38,169.62l1,.52c8.86,4.5,21.91,6.44,34.48,7.11V156.18l-.09.09C200.74,162.1,182.66,165.59,171.38,169.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M166.27,164.67v1.06a.23.23,0,0,0,0,.12c.24,1.57,2.08,3.32,6.09,5.35,8.86,4.5,21.91,6.44,34.48,7.11h0a269.34,269.34,0,0,0,37.48-.86v-1.06a270.27,270.27,0,0,1-37.48.85h0c-12.57-.67-25.62-2.6-34.48-7.1a25.63,25.63,0,0,1-3.52-2.11,10.23,10.23,0,0,1-.82-.65,2.44,2.44,0,0,1-.3-.27,4.08,4.08,0,0,1-.36-.36,3.74,3.74,0,0,1-.27-.31c-.09-.1-.16-.21-.24-.31a2.2,2.2,0,0,1-.19-.3l-.15-.26a1.46,1.46,0,0,1-.12-.33,1.84,1.84,0,0,1-.09-.28l0-.17A.27.27,0,0,1,166.27,164.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M166.27,251.76v1.06a.3.3,0,0,0,0,.13c.24,1.56,2.08,3.31,6.09,5.34,8.86,4.51,21.91,6.44,34.48,7.11h0a270.27,270.27,0,0,0,37.48-.85v-1.07a269.34,269.34,0,0,1-37.48.86h0c-12.57-.68-25.62-2.61-34.48-7.11a24.66,24.66,0,0,1-3.52-2.11c-.31-.22-.58-.44-.82-.64s-.2-.18-.3-.27a4.17,4.17,0,0,1-.36-.37,3.74,3.74,0,0,1-.27-.31,3.5,3.5,0,0,1-.24-.3,3.21,3.21,0,0,1-.19-.31l-.15-.25a1.74,1.74,0,0,1-.12-.34,1.84,1.84,0,0,1-.09-.28l0-.17A.23.23,0,0,1,166.27,251.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M160.84,118.34v1.07s44.56,15.46,46,25.45c0-.08,0-.16,0-.25v-.56C206.19,134.08,160.84,118.34,160.84,118.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M166.27,164.21a1.77,1.77,0,0,0,0,.46.27.27,0,0,0,0,.12l0,.17a3.56,3.56,0,0,1,1.15-1.75c.1-.1.21-.18.32-.28A15.46,15.46,0,0,1,171,161l.92-.39a7.56,7.56,0,0,1,.71-.3c.21-.08.41-.17.62-.24,4-1.55,9.33-3,14.53-4.53l2.15-.63.31-.1.8-.25c1-.3,2-.62,2.94-.94l.24-.08c.71-.24,1.41-.48,2.08-.73l.19-.07.73-.27,1.26-.49c1-.4,1.9-.81,2.76-1.22l.59-.31a19.22,19.22,0,0,0,3.06-1.92c.29-.22.54-.45.79-.68a3.49,3.49,0,0,0,1.16-2.19v-1.07c0,.09,0,.17,0,.25h0v0a3.17,3.17,0,0,1-.12.44l0,0a3.58,3.58,0,0,1-.24.48,2.19,2.19,0,0,1-.28.42.19.19,0,0,1-.06.07,2.39,2.39,0,0,1-.4.45C197.87,154.39,166.9,157.45,166.27,164.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "244.39 176.39 244.39 264.55 243.41 264.62 243.9 176.39 244.39 176.39"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M166.27,192.91v45.35c7.59-3.2,12.77-11,12.74-20.91A30.47,30.47,0,0,0,166.27,192.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M181.83,173.66a118,118,0,0,0,22.64,3.49A19.93,19.93,0,0,0,187.7,172,23.78,23.78,0,0,0,181.83,173.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M212.52,240.8a1.91,1.91,0,0,0-1,.65,2,2,0,0,0-.31,1.25v6.61a.81.81,0,0,1-.09.4,2.12,2.12,0,0,1-.57.49l-.8-.82-.23.24,1.94,2,1.77-1-.49-.77v-5.91a3.16,3.16,0,0,1,.06-.82,1.11,1.11,0,0,1,.36-.55l.29-.1a.82.82,0,0,1,.41.27l.26.27.22-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M204.4,239.66a7.75,7.75,0,0,1,2.43,2.79,7.41,7.41,0,0,1,.92,3.46,5.54,5.54,0,0,1-.45,2.22,4.06,4.06,0,0,1-1.3,1.68,4.23,4.23,0,0,1-1.91.74,9.73,9.73,0,0,1-2.32-2.83,7.08,7.08,0,0,1-.87-3.4,5,5,0,0,1,.92-3.06A4.37,4.37,0,0,1,204.4,239.66Zm-2.21,7.65a7.79,7.79,0,0,0,.75,1.56,3.49,3.49,0,0,0,1.87-.59,3.91,3.91,0,0,0,1.4-1.61,5.22,5.22,0,0,0,.48-2.25,5.12,5.12,0,0,0-1-3.12,5,5,0,0,0-2,.78,4,4,0,0,0-1.28,1.57,5.3,5.3,0,0,0-.42,2.11,5.14,5.14,0,0,0,.23,1.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M196.77,238.59a7.75,7.75,0,0,1,2.43,2.79,7.6,7.6,0,0,1,.91,3.45,5.59,5.59,0,0,1-.45,2.23,3.89,3.89,0,0,1-1.3,1.67,4,4,0,0,1-1.9.74,9.89,9.89,0,0,1-2.33-2.82,7.12,7.12,0,0,1-.86-3.4,4.92,4.92,0,0,1,.92-3.06A4.31,4.31,0,0,1,196.77,238.59Zm-2.22,7.64a7.17,7.17,0,0,0,.76,1.57,3.51,3.51,0,0,0,1.86-.59,4,4,0,0,0,1.4-1.61,5.26,5.26,0,0,0,.49-2.25,5.16,5.16,0,0,0-1-3.13,5.15,5.15,0,0,0-2,.79,3.84,3.84,0,0,0-1.29,1.56,5.33,5.33,0,0,0-.42,2.11,5.14,5.14,0,0,0,.23,1.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M160.85,118.34V206.5s2.11.73,5.43,2V164.67a1.19,1.19,0,0,1,0-.46c.62-6.76,31.59-9.82,39.42-17.41a3.52,3.52,0,0,0,1.16-2.19v-.56C206.18,134.08,160.85,118.34,160.85,118.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M166.56,163.29c-1.35,2.33,1.86,4.84,5.82,6.85,8.86,4.5,21.91,6.43,34.48,7.1V156.77a77.14,77.14,0,0,0-12.89,0C175.61,158.27,166.56,163.29,166.56,163.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M166.27,164.67V188.2c7.92,19.05,27.33,47.42,74.65,76.65,2.21-.17,3.47-.3,3.47-.3V176.39a268.46,268.46,0,0,1-37.48.85h0c-12.57-.67-25.62-2.6-34.48-7.1-4-2-5.85-3.78-6.09-5.35A.27.27,0,0,1,166.27,164.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79,72.08,79,108.2a19.91,19.91,0,0,0,8.6,3.47C98,113.12,106.42,105.22,106.39,94s-8.46-21.5-18.85-23A16.45,16.45,0,0,0,79,72.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M70.82,77C60.43,75.56,52,83.46,52,94.69s8.46,21.48,18.85,22.94,18.8-6.44,18.78-17.65S81.21,78.48,70.82,77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M68.12,78.54C57.73,77.08,49.32,85,49.34,96.2s8.46,21.49,18.85,23S87,112.71,87,101.49,78.51,80,68.12,78.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M49.33,96.21c0,11.2,8.47,21.48,18.86,22.94a17.31,17.31,0,0,0,2.67.16,14.44,14.44,0,0,1-1.85-.16c-10.39-1.46-18.83-11.74-18.86-22.94,0-10.21,6.93-17.66,16-17.83C56.69,78.11,49.32,85.7,49.33,96.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M87,101.49c0,10.19-6.91,17.65-16,17.82,9.46.27,16.83-7.32,16.81-17.82,0-11.22-8.47-21.5-18.86-22.95a16,16,0,0,0-2.66-.16,14.44,14.44,0,0,1,1.84.16C78.5,80,87,90.27,87,101.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.19,88.33a1.81,1.81,0,0,0-1.61.54,2.53,2.53,0,0,0,.15,3.34l14.88,16.62,9.73-5.8a2.32,2.32,0,0,0,.57-3.18,2.56,2.56,0,0,0-1.81-1.29,1.81,1.81,0,0,0-1.22.24L71,102.9,58.66,89.14A2.4,2.4,0,0,0,57.19,88.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.59,3.74c-9.41-1.32-17,5.83-17,16s7.66,19.45,17.07,20.77,17-5.83,17-16S183,5.06,173.59,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.76,2.2c-9.4-1.32-17,5.83-17,16S166.43,37.64,175.83,39s17-5.83,17-16S185.17,3.52,175.76,2.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M158.76,18.18c0,10.16,7.67,19.46,17.07,20.78a17.11,17.11,0,0,0,2.64.15c-.6,0-1.2-.07-1.82-.15-9.41-1.32-17-10.62-17.07-20.78,0-9.19,6.22-15.9,14.35-16.12C165.39,1.82,158.75,8.69,158.76,18.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175.74,35.48c-7.59-1.07-13.78-8.59-13.8-16.77a13.52,13.52,0,0,1,4.39-10.3,11.75,11.75,0,0,1,9.52-2.73l-.08.56.08-.56c7.59,1.07,13.78,8.59,13.8,16.77a13.54,13.54,0,0,1-4.39,10.31,11.63,11.63,0,0,1-7.71,2.85A12.44,12.44,0,0,1,175.74,35.48ZM167.07,9.25a12.22,12.22,0,0,0-4,9.46c0,7.64,5.77,14.67,12.83,15.66a10.65,10.65,0,0,0,8.62-2.46,12.39,12.39,0,0,0,4-9.46c0-7.64-5.77-14.66-12.83-15.66h0A13.19,13.19,0,0,0,174,6.68,10.51,10.51,0,0,0,167.07,9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M212.6,47.46a19.37,19.37,0,0,0-16.55,21.36,18.46,18.46,0,0,0,20.71,16.49A19.38,19.38,0,0,0,233.32,64,18.47,18.47,0,0,0,212.6,47.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.64,48.14A19.37,19.37,0,0,0,198.09,69.5,18.46,18.46,0,0,0,218.8,86a19.38,19.38,0,0,0,16.56-21.35A18.47,18.47,0,0,0,214.64,48.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.09,69.5a18.49,18.49,0,0,0,18.64,16.64,18.5,18.5,0,0,1-18-16.64,19.39,19.39,0,0,1,16.57-21.36,14.38,14.38,0,0,1,2.06-.15,16,16,0,0,0-2.75.15A19.37,19.37,0,0,0,198.09,69.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.29,79.36A15.11,15.11,0,0,1,201.59,69,15.73,15.73,0,0,1,215,51.72a14.79,14.79,0,0,1,11.13,3.05,15.11,15.11,0,0,1,5.7,10.34,15.71,15.71,0,0,1-13.43,17.3,14.59,14.59,0,0,1-2,.13A14.75,14.75,0,0,1,207.29,79.36Zm7.88-26.53h0A14.6,14.6,0,0,0,202.71,68.9,14,14,0,0,0,208,78.48a13.69,13.69,0,0,0,10.3,2.81,14.58,14.58,0,0,0,12.45-16.06,14,14,0,0,0-5.27-9.58A13.65,13.65,0,0,0,217,52.72,15.87,15.87,0,0,0,215.17,52.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M224.52,107.4c-10.33,1.86-15.37,7.85-11.27,13.37s15.8,8.48,26.13,6.62,15.37-7.85,11.27-13.36S234.84,105.54,224.52,107.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.52,104.36c-10.33,1.87-15.37,7.85-11.27,13.37s15.8,8.48,26.13,6.62,15.37-7.85,11.27-13.36S234.84,102.5,224.52,104.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.26,117.73c4.1,5.52,15.79,8.48,26.12,6.62a26.18,26.18,0,0,0,5.86-1.71,28,28,0,0,1-5,1.34c-10.33,1.88-22-1.1-26.13-6.62-3.23-4.33-.8-9,5.37-11.63C212.68,108.35,209.88,113.19,213.26,117.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216.66,117.35a5.3,5.3,0,0,1-.88-5.29c1.15-2.92,4.95-5.22,10.17-6.16h0c8.37-1.51,17.93.94,21.29,5.47a5.28,5.28,0,0,1,.88,5.28c-1.15,2.92-5,5.22-10.17,6.16a28.22,28.22,0,0,1-5.11.45C226,123.26,219.35,121,216.66,117.35Zm9.47-10.43c-4.85.88-8.36,2.94-9.38,5.52a4.29,4.29,0,0,0,.74,4.29c3.15,4.24,12.25,6.51,20.28,5.06,4.85-.88,8.36-2.94,9.38-5.52a4.28,4.28,0,0,0-.74-4.28c-2.51-3.38-8.78-5.5-15.28-5.5A28.85,28.85,0,0,0,226.13,106.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.85,27.5a4.86,4.86,0,1,0,4.85-4.86A4.85,4.85,0,0,0,210.85,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.31,3.43A3.44,3.44,0,1,0,67.74,0,3.43,3.43,0,0,0,64.31,3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.46,98.67a2.42,2.42,0,1,0,2.42-2.42A2.42,2.42,0,0,0,206.46,98.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239.27,87.48A1.71,1.71,0,1,0,241,85.77,1.72,1.72,0,0,0,239.27,87.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M246.11,151.87a3.74,3.74,0,1,0,3.74-3.73A3.74,3.74,0,0,0,246.11,151.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "253.58 141.17 253.07 144.95 249.29 145.46 253.07 145.97 253.58 149.75 254.09 145.97 257.87 145.46 254.09 144.95 253.58 141.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "219.53 95.4 219.02 99.18 215.24 99.69 219.02 100.2 219.53 103.98 220.04 100.2 223.83 99.69 220.04 99.18 219.53 95.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "154.06 29.55 153.34 34.89 148 35.61 153.34 36.33 154.06 41.67 154.78 36.33 160.13 35.61 154.78 34.89 154.06 29.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "56.83 28.42 56.1 33.76 50.76 34.48 56.1 35.21 56.83 40.55 57.55 35.21 62.89 34.48 57.55 33.76 56.83 28.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "17.65 97.64 17.24 100.68 14.21 101.09 17.24 101.5 17.65 104.53 18.06 101.5 21.09 101.09 18.06 100.68 17.65 97.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M7.93,142.66c-3.48-.49-6.31,2.18-6.31,6l.13,69.08a7.86,7.86,0,0,0,6.34,7.72l106.83,15c3.5.49,6.33-2.17,6.32-6l-.13-69.08a7.86,7.86,0,0,0-6.35-7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M6.31,143.87C2.82,143.38,0,146,0,149.82L.13,218.9a7.86,7.86,0,0,0,6.33,7.72l106.84,15c3.49.5,6.32-2.17,6.32-5.94l-.13-69.08a7.87,7.87,0,0,0-6.35-7.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.09,165.69v1L77,167a1.21,1.21,0,0,1,.74.4,1.15,1.15,0,0,1,.27.74v5.26a.85.85,0,0,1-.27.66.9.9,0,0,1-.73.19l-1.87-.26v1l1.74.24a1.71,1.71,0,0,0,2.2-1.93v-4.76a2.54,2.54,0,0,0-.57-1.76,2.61,2.61,0,0,0-1.64-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.49,168.09v-1.27a1.82,1.82,0,0,1,.53-1.49,2.08,2.08,0,0,1,1.58-.27l2.29.32,0,9.25-1.06-.15v-3.83l-1.2-.16-1.57,3.6-1.16-.17,1.69-3.81A2,2,0,0,1,68.49,168.09Zm2,1.38,1.38.19v-3.44L70.45,166a.82.82,0,0,0-.68.13.92.92,0,0,0-.22.69v1.52a1.14,1.14,0,0,0,.22.77,1.07,1.07,0,0,0,.68.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "61.79 163.82 61.8 164.78 64.82 165.21 64.82 168.24 62.1 167.86 62.1 168.82 64.82 169.2 64.83 172.53 61.81 172.11 61.81 173.07 65.9 173.64 65.88 164.4 61.79 163.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.16,163.17l2.37.33v9.25L57,172.4a2.57,2.57,0,0,1-1.6-.7,2.51,2.51,0,0,1-.49-1.68v-5.1a1.75,1.75,0,0,1,.56-1.5A2.3,2.3,0,0,1,57.16,163.17ZM56,170.3a1.17,1.17,0,0,0,.23.76,1,1,0,0,0,.69.33l1.56.22,0-7.27-1.58-.22a.81.81,0,0,0-.64.17A.87.87,0,0,0,56,165v5.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "48.99 162.02 48.99 162.98 50.09 163.14 50.1 170.46 49 170.31 49 171.27 52.27 171.73 52.27 170.77 51.17 170.61 51.15 163.29 52.26 163.44 52.25 162.48 48.99 162.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "41.53 160.97 41.53 161.98 43.48 162.25 43.49 170.49 44.56 170.64 44.54 162.4 46.49 162.67 46.49 161.67 41.53 160.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.82,159.19v1l1.86.26a1.18,1.18,0,0,1,.74.4,1.14,1.14,0,0,1,.27.73v5.27a.81.81,0,0,1-1,.84l-1.86-.26v1l1.74.25a2,2,0,0,0,1.63-.33,2,2,0,0,0,.57-1.6V162a2.54,2.54,0,0,0-.57-1.76,2.56,2.56,0,0,0-1.64-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.86,158.63,27,168.17,25.86,168l-.48-2.41L23,165.27l-.46,2.28-1.09-.16,2-9Zm.32,6-1-5.18-1,4.9,2,.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M15.61,160.66v-1.27a1.82,1.82,0,0,1,.53-1.49,2,2,0,0,1,1.58-.27L20,158l0,9.25L19,167.05v-3.83l-1.2-.17-1.57,3.61L15,166.49l1.7-3.81A2,2,0,0,1,15.61,160.66Zm2,1.38,1.37.19v-3.44l-1.38-.19a.79.79,0,0,0-.68.13.92.92,0,0,0-.22.69v1.52a1.11,1.11,0,0,0,.22.76,1,1,0,0,0,.68.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.89,156.67l2.36.33,0,9.25-2.51-.36a2.52,2.52,0,0,1-1.6-.7,2.47,2.47,0,0,1-.49-1.67v-5.1a1.72,1.72,0,0,1,.56-1.5A2.2,2.2,0,0,1,10.89,156.67ZM9.73,163.8a1.21,1.21,0,0,0,.22.76,1.07,1.07,0,0,0,.69.33l1.56.22v-7.27l-1.58-.22a.74.74,0,0,0-.64.17.82.82,0,0,0-.25.66v5.35"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2.18,224.2a7,7,0,0,0,4.28,2.42l106.84,15c3.5.49,6.33-2.18,6.31-5.95l-.12-69.08a8.25,8.25,0,0,0-2.79-6,8.08,8.08,0,0,1,2,5.29l.13,69.08c0,3.77-2.82,6.43-6.32,5.94l-106.82-15A6.7,6.7,0,0,1,2.18,224.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M0,149.82.12,218.9A8.24,8.24,0,0,0,2.93,225a8.28,8.28,0,0,1-2.12-5.38L.7,150.5c0-3.77,2.8-6.43,6.31-5.94l106.82,15a6.71,6.71,0,0,1,3.53,1.67,6.9,6.9,0,0,0-4.23-2.35l-106.82-15C2.83,143.38,0,146,0,149.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M84,178.62l18,2.54a3.79,3.79,0,0,1,3.06,3.72l0,15.84a2.68,2.68,0,0,1-3,2.86l-18-2.53a3.79,3.79,0,0,1-3.07-3.72l0-15.84A2.7,2.7,0,0,1,84,178.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M15.66,208.43c3.26.46,5.9,3.9,5.91,7.69s-2.63,6.49-5.88,6-5.91-3.9-5.92-7.69S12.4,208,15.66,208.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.92,199.53v-1.62a.79.79,0,0,1,.2-.58.5.5,0,0,1,.49-.19l2.48.35.24.16a.59.59,0,0,1,.11.32.47.47,0,0,1-.11.29l-.24.09L20.61,198v1.67a.51.51,0,0,0,.1.32l.25.16,1.4.2.24.16a.52.52,0,0,1,.11.32.4.4,0,0,1-.11.29l-.24.1L21,201l-.24.1a.39.39,0,0,0-.11.28v1.69l2.45.35.25.16a.58.58,0,0,1,.1.32.44.44,0,0,1-.1.29l-.25.09L20.63,204a.71.71,0,0,1-.5-.33,1,1,0,0,1-.21-.64v-1.68a1.27,1.27,0,0,1,.3-.83A1.58,1.58,0,0,1,19.92,199.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.16,207.9l2.48.34.25.17a.58.58,0,0,1,.1.32.48.48,0,0,1-.1.29l-.25.09-2.48-.35v2.1l2.1.3a.69.69,0,0,1,.49.32,1.1,1.1,0,0,1,.21.65v3l-3.15-.44-.25-.16a.55.55,0,0,1-.1-.32.39.39,0,0,1,.1-.29l.24-.1,2.46.35V212l-2.11-.3a.75.75,0,0,1-.49-.33,1.05,1.05,0,0,1-.21-.65v-2.09a.83.83,0,0,1,.2-.59A.53.53,0,0,1,97.16,207.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.44,203.11v-1.62a.78.78,0,0,1,.2-.58.51.51,0,0,1,.49-.19l2.48.35.23.16a.55.55,0,0,1,.1.32.44.44,0,0,1-.09.29l-.24.1-2.48-.35v1.67a.57.57,0,0,0,.1.31l.25.17,1.4.2.24.16a.46.46,0,0,1,.11.32.36.36,0,0,1-.11.29l-.24.09-1.4-.19-.24.09a.44.44,0,0,0-.1.29v1.69l2.44.34.25.17a.51.51,0,0,1,.1.32.48.48,0,0,1-.09.29l-.25.09-2.45-.34a.77.77,0,0,1-.5-.33,1.07,1.07,0,0,1-.21-.64v-1.69a1.3,1.3,0,0,1,.29-.82A1.6,1.6,0,0,1,45.44,203.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M41,200l2.47.34.25.17a.51.51,0,0,1,.1.32.43.43,0,0,1-.1.29l-.25.09L41,200.87V203l2.1.3a.71.71,0,0,1,.49.32,1.1,1.1,0,0,1,.2.66v3l-3.15-.44-.24-.16a.48.48,0,0,1-.11-.32.36.36,0,0,1,.11-.29l.24-.1,2.45.35v-2.11l-2.1-.3a.74.74,0,0,1-.5-.33,1.05,1.05,0,0,1-.21-.65v-2.09a.79.79,0,0,1,.21-.59A.52.52,0,0,1,41,200Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M71.66,204.31l2.46.35.25.16a.51.51,0,0,1,.1.32.39.39,0,0,1-.1.29l-.25.09-2.46-.34v2.1l2.1.29a.7.7,0,0,1,.49.33,1,1,0,0,1,.2.65v3l-3.15-.45-.25-.16a.51.51,0,0,1-.1-.32.39.39,0,0,1,.1-.29l.25-.09,2.45.34v-2.11l-2.1-.29a.81.81,0,0,1-.5-.33,1.09,1.09,0,0,1-.2-.65v-2.1a.79.79,0,0,1,.21-.58A.52.52,0,0,1,71.66,204.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25.72,197.85l2.47.35.25.17a.51.51,0,0,1,.1.32.48.48,0,0,1-.09.29l-.25.09-2.48-.35v2.1l2.11.3a.7.7,0,0,1,.49.32,1.1,1.1,0,0,1,.21.65v3l-3.15-.44-.25-.16a.63.63,0,0,1-.1-.32.44.44,0,0,1,.1-.29l.25-.1,2.46.35V202l-2.1-.3a.73.73,0,0,1-.49-.33,1,1,0,0,1-.21-.65v-2.1a.83.83,0,0,1,.21-.58A.54.54,0,0,1,25.72,197.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M15.19,200.1l.25.17.1.31v1.8l.7.1,0-6,1.74.24.25.17a.51.51,0,0,1,.1.32.41.41,0,0,1-.1.29l-.25.09-1-.14v5.08l1.07.15.23.17.11.3a.48.48,0,0,1-.1.31l-.24.09-2.81-.39L15,203a.51.51,0,0,1-.1-.32v-2.22a.36.36,0,0,1,.11-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M9.84,199.48l.24-.1.25.17.1.32v1.79l.7.1v-6l1.74.25.25.16a.58.58,0,0,1,.1.32.44.44,0,0,1-.1.29l-.25.09-1-.14v5.09l1.06.15.25.16.1.31a.45.45,0,0,1-.1.3l-.25.09-2.8-.39-.24-.16a.51.51,0,0,1-.1-.32v-2.23A.44.44,0,0,1,9.84,199.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.43,208.71l.25.16.1.32V211l.7.09v-6l1.74.24.25.17a.56.56,0,0,1,.09.31.49.49,0,0,1-.09.3l-.25.09-1.06-.15v5.09l1.07.15.25.16.1.31a.49.49,0,0,1-.1.3l-.25.1-2.79-.4-.25-.16a.51.51,0,0,1-.1-.32v-2.23a.48.48,0,0,1,.1-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102,212.3l.25.16.1.32v1.79l.69.1v-6l1.74.25.24.16a.46.46,0,0,1,.11.32.36.36,0,0,1-.11.29l-.24.1-1-.15v5.09l1.06.15.25.16.1.31a.47.47,0,0,1-.1.3l-.24.09-2.8-.39-.25-.16a.71.71,0,0,1-.1-.32v-2.23a.39.39,0,0,1,.1-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35.61,203l.24.16.1.32v1.8l.7.09,0-6,1.74.24.25.17a.51.51,0,0,1,.1.32.43.43,0,0,1-.1.29l-.25.09-1-.15v5.09l1.07.15.25.17.09.3a.54.54,0,0,1-.09.31l-.25.09-2.79-.39-.25-.17a.51.51,0,0,1-.1-.32v-2.22a.44.44,0,0,1,.1-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.08,205.13V202.6a.44.44,0,0,1,.1-.29l.25-.09.24.16a.58.58,0,0,1,.1.32v2.53l1.39.2v-3.29a.47.47,0,0,1,.1-.3l.24-.09.25.16a.59.59,0,0,1,.11.33v4.16l-2.1-.29v1.79a.39.39,0,0,1-.1.29l-.24.1-.25-.16a.63.63,0,0,1-.1-.32V206l-.25-.16a.51.51,0,0,1-.1-.32.39.39,0,0,1,.1-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.28,206.57V204a.4.4,0,0,1,.11-.29l.24-.1.25.16a.55.55,0,0,1,.1.32v2.54l1.39.19v-3.28a.49.49,0,0,1,.09-.3l.25-.1.25.17a.56.56,0,0,1,.1.33v4.16l-2.09-.3v1.8a.39.39,0,0,1-.1.29l-.25.09-.24-.16a.52.52,0,0,1-.11-.32v-1.8l-.24-.17a.46.46,0,0,1-.11-.32.38.38,0,0,1,.11-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.85,206v-1.62a.82.82,0,0,1,.2-.58.49.49,0,0,1,.49-.19l2.48.35.24.16a.55.55,0,0,1,.1.32.39.39,0,0,1-.1.29l-.24.1-2.48-.35v1.66a.58.58,0,0,0,.1.32l.25.17,1.4.19.25.17a.51.51,0,0,1,.1.32.48.48,0,0,1-.09.29l-.25.09-1.39-.19-.25.09a.39.39,0,0,0-.1.29v1.69l2.45.34.23.17a.5.5,0,0,1,.1.31.44.44,0,0,1-.09.29l-.24.1-2.46-.34a.77.77,0,0,1-.5-.33,1.22,1.22,0,0,1-.21-.64v-1.69a1.35,1.35,0,0,1,.29-.83A1.64,1.64,0,0,1,65.85,206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.79,210.15v-2.53a.36.36,0,0,1,.11-.29l.24-.09.25.16a.57.57,0,0,1,.09.32v2.53l1.39.2v-3.29a.54.54,0,0,1,.1-.3l.25-.09.25.16a.56.56,0,0,1,.1.33v4.16l-2.09-.29v1.79a.49.49,0,0,1-.09.3l-.25.09-.24-.16a.5.5,0,0,1-.11-.32V211l-.24-.16a.52.52,0,0,1-.11-.32.4.4,0,0,1,.11-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.37,209.57V208a.79.79,0,0,1,.21-.58.49.49,0,0,1,.49-.19l2.47.35.24.16a.46.46,0,0,1,.11.32.36.36,0,0,1-.11.29l-.24.09-2.47-.34v1.66a.51.51,0,0,0,.1.32l.25.16,1.4.2.25.16a.53.53,0,0,1,.1.32.39.39,0,0,1-.1.29l-.25.1-1.39-.2-.25.1a.44.44,0,0,0-.1.29v1.69l2.44.34.24.16a.51.51,0,0,1,.1.32.39.39,0,0,1-.1.29l-.24.1L92.07,214a.71.71,0,0,1-.5-.33,1.09,1.09,0,0,1-.21-.64v-1.68a1.26,1.26,0,0,1,.29-.83A1.57,1.57,0,0,1,91.37,209.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M17.65,145.46,94.7,239l18.59,2.61c3.5.49,6.33-2.16,6.33-5.94l-.13-69.08a7.86,7.86,0,0,0-6.34-7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M26.44,129.78a1.72,1.72,0,0,0,.39,0,1.84,1.84,0,0,0,1.41-2.18L27.91,126a1.84,1.84,0,0,0-3.6.73c.11.54.22,1.07.34,1.6A1.84,1.84,0,0,0,26.44,129.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M24.9,121.39a1.32,1.32,0,0,0,.28,0,1.83,1.83,0,0,0,1.54-2.08c-.36-2.41-.65-4.85-.87-7.27a1.84,1.84,0,1,0-3.66.33c.23,2.49.53,5,.9,7.48A1.84,1.84,0,0,0,24.9,121.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M23.56,106.27h.06a1.83,1.83,0,0,0,1.78-1.88c0-1.07,0-2.14,0-3.21C25.29,71,36.29,44.35,56.3,26.11c18.06-16.45,41.84-24.2,67-21.81a1.83,1.83,0,1,0,.35-3.65c-26.17-2.49-51,5.59-69.79,22.75C33,42.34,21.62,70,21.68,101.18c0,1.11,0,2.21.05,3.31A1.83,1.83,0,0,0,23.56,106.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M138.88,7a1.83,1.83,0,0,0,.45-3.61c-2.75-.7-5.56-1.3-8.35-1.77a1.84,1.84,0,1,0-.61,3.62c2.69.46,5.4,1,8.06,1.7A1.74,1.74,0,0,0,138.88,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M147.64,9.63a1.83,1.83,0,0,0,.6-3.57l-1.73-.58A1.83,1.83,0,0,0,145.36,9l1.68.57A1.8,1.8,0,0,0,147.64,9.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M21.87,94c2-27.39,13.13-51.47,31.82-68.52C72.53,8.31,97.31.23,123.49,2.72a1.8,1.8,0,0,1,1.39.89,1.76,1.76,0,0,0,.39-.95,1.84,1.84,0,0,0-1.65-2c-26.17-2.5-51,5.59-69.79,22.75C34.66,40.87,23.45,65.73,21.87,94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M128.86,3.12a1.83,1.83,0,0,0,.24,1.26,1.79,1.79,0,0,1,1.75-.68c2.78.46,5.59,1.06,8.35,1.76a1.75,1.75,0,0,1,1.12.83,1.81,1.81,0,0,0-1-2.9c-2.75-.71-5.57-1.3-8.36-1.77A1.85,1.85,0,0,0,128.86,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M144.36,8.15a1.84,1.84,0,0,1,2-.6l1.74.58a1.77,1.77,0,0,1,1,.8,2,2,0,0,0,.3-.54,1.83,1.83,0,0,0-1.14-2.33l-1.73-.59a1.84,1.84,0,0,0-2.15,2.68Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M176.07,287.85a13,13,0,0,0,2.5,5.19c5.43,7.06,21.08,15.69,64.81,16.68h0a1.22,1.22,0,0,0,1.22-1.19,1.25,1.25,0,0,0-1.2-1.26c-42.53-1-57.63-9-62.82-15.59a11.45,11.45,0,0,1-1.92-3.43Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLillyPaymentHero);
export default __webpack_public_path__ + "static/media/lilly-payment-hero.9126436dd9752d060866f45b0ae13c5c.svg";
export { ForwardRef as ReactComponent };